export const getPermissionNames = (userDataRaw) => {
 const userData = userDataRaw?.user || userDataRaw || {};

 // If server has provided permissionNames, use ONLY those — they are the authoritative override
 if (Array.isArray(userData.permissionNames) && userData.permissionNames.length > 0) {
 return [...new Set(
 userData.permissionNames
 .map(p => (typeof p === 'string' ? p : p?.name || ''))
 .filter(Boolean)
 )];
 }

 // Fallback: derive from role permissions if permissionNames not provided
 const fallbackSources = [
 userData.permissions,
 userData.userPermissions,
 userData.directPermissions,
 userData.role?.permissions,
 ];

 const names = fallbackSources
 .flatMap((source) => (Array.isArray(source) ? source : []))
 .map((permission) => {
 if (!permission) return "";
 if (typeof permission === "string") return permission;
 return permission.name || permission.permission || "";
 })
 .filter(Boolean);

 return [...new Set(names)];
};
